export const Radio = {
  baseStyle: () => ({
    control: {
      border: '2px solid',
      borderColor: 'product.border.solid',

      _checked: {
        background: 'white',
        borderColor: `product.secondary`,
        color: `product.secondary`,
        _before: {
          width: 2.5,
          height: 2.5,
        },
        _hover: {
          background: 'white',
          borderColor: `product.secondary`,
        },
      },
    },
  }),
  variants: {
    suggestion: {
      control: {
        borderColor: 'gray.50',
      },
    },
  },
}
